export function getRequiredHouseholdMemberRowCount(totalMembers: string | null | undefined) {
  const normalized = totalMembers?.trim() ?? "";

  if (!/^0*[1-9]\d{0,2}$/.test(normalized)) {
    return null;
  }

  return Number(normalized);
}

export function createMissingHouseholdMemberRows<T>(
  totalMembers: string | null | undefined,
  currentRowCount: number,
  createBlankRow: () => T,
) {
  const requiredRowCount = getRequiredHouseholdMemberRowCount(totalMembers);
  const missingRowCount = requiredRowCount === null
    ? 0
    : Math.max(0, requiredRowCount - currentRowCount);

  return Array.from({ length: missingRowCount }, createBlankRow);
}

export function isHouseholdMemberRowBlank(
  member: Record<string, unknown> | null | undefined,
) {
  if (!member) return true;

  return Object.values(member).every((value) =>
    value === undefined ||
    value === null ||
    value === "" ||
    value === false ||
    (Array.isArray(value) && value.length === 0),
  );
}
